module.exports = __webpack_public_path__ + "static/media/triangle.4dcfd756.svg";